import Immutable from 'seamless-immutable';

import { createReducer, createActions } from 'reduxsauce';

export const { Types, Creators } = createActions({
  geoEncodedClean: [],

  geoEncodedRequest: ['lat', 'lng', 'sellerId'],
  geoEncodedSuccess: ['data'],
  geoEncodedFailed: ['error'],

  geoCleanError: [],
});

const INITIAL_STATE = Immutable({
  isLoading: false,
  error: {},
  postalCode: null,
  address: null,
  streetNumber: null,
  streetName: null,
  neighborhood: null,
  city: null,
  stateShort: null,
  stateLong: null,
  addresFormated: null,
});

const geoEncodedRequest = (state = INITIAL_STATE) =>
  state.merge({
    ...INITIAL_STATE,
    isLoading: true,
  });

const geoCleanError = (state = INITIAL_STATE) => state.merge({ error: {} });

const geoEncodedSuccess = (state = INITIAL_STATE, { data }) => state.merge(data).set('isLoading', false);

const geoEncodedFailed = (state = INITIAL_STATE, { error }) => state.merge({ error, isLoading: false });

const geoEncodedClean = (state = INITIAL_STATE) =>
  state.merge({ isLoading: false, postalCode: null, address: null, error: {} });

export default createReducer(INITIAL_STATE, {
  [Types.GEO_ENCODED_CLEAN]: geoEncodedClean,

  [Types.GEO_ENCODED_REQUEST]: geoEncodedRequest,
  [Types.GEO_ENCODED_SUCCESS]: geoEncodedSuccess,
  [Types.GEO_ENCODED_FAILED]: geoEncodedFailed,

  [Types.GEO_CLEAN_ERROR]: geoCleanError,
});
